import {
    apiRequest,
    penilaianList,
    penilaianDetail,
    penilaianComponent,
    penilaianDraft,
    penilaianFinish,
    penilaianBegin
} from "../../../../../services/adapters/kepegawaian/penilaian360Service"

class PenilaianRepository {

    fetchBegin = async (query) => {
        return await apiRequest("post", penilaianBegin, {
            body: query
        }, true)
    }


    fetchPenilaianList = async (query, cancelToken) => {
        return await apiRequest("get", penilaianList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchPenilaianDetail = async (query) => {
        return await apiRequest("get", penilaianDetail, {
            params: query
        }, true)
    }

    fetchPenilaianComponent = async (query) => {
        return await apiRequest("get", penilaianComponent, {
            params: query
        }, true)
    }

    fetchSubmitDraft = async (query) => {
        return await apiRequest("post", penilaianDraft, {
            body: query
        }, true)
    }

    fetchSubmitFinish = async (query) => {
        return await apiRequest("post", penilaianFinish, {
            body: query
        }, true)
    }

}

export default PenilaianRepository